{
  "disclosure": "Disclosure",
  "loan-terms": "Loan Terms",
  "projected-payments": "Projected Payments",
  "cash-to-close": "Cash To Close",
  "liability-after-foreclosure": "Liability After Foreclosure",
  "loan-calculations": "Loan Calculations",
  "if-you-lender": " If your lender forecloses on this property and the foreclosure does not cover the amount of unpaid balance on this loan",
  "protects-from-unpaid-balance-liability": "Protects from unpaid balance liability",
  "dont-protects-from-unpaid-balance-liability": "Does not protect from unpaid balance liability",
  "loan-amount": "Loan Amount",
  "interest-rate": "Interest Rate",
  "monthly-principal-interest": "Monthly Principal Interest",
  "prepayment-penalty": "Prepayment Penalty",
  "balloon-payment": "Balloon Payment",
  "can-increase": "Can Increase",
  "cannot-increase": "Cannot Increase"
}
